import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  type QuickBooksAccountConstructor,
  QuickBooksAccount,
} from './QuickBooksAccount'

export const QuickBooksAccountConstructorFactory =
  Factory.Sync.makeFactory<QuickBooksAccountConstructor>({
    listId: Factory.each(() => faker.random.uuid()),
    accountNumber: Factory.each(() => String(faker.random.number(9999))),
    accountType: 'Expense',
    name: Factory.each(() => faker.commerce.department()),
    description: Factory.each(() => faker.lorem.sentence()),
  })

export const QuickBooksAccountFactory = EntityFactory(
  QuickBooksAccount,
  QuickBooksAccountConstructorFactory
)
